import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalConfirmationComponent } from '../component/modal-confirmation/modal-confirmation.component';
import { ModalDialogComponent } from '../component/modal-dialog/modal-dialog.component';
import { IModalConfirmation } from '../interface/modal.interface';
import { Subscription } from 'rxjs';
import { AuthService } from '../guards/auth.service';
import {
  IModalButton,
  IModalButtonType,
  IModalConfirmationForDeleteAndRestore,
} from '../../shared/interface/modal.interface';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class DynamicDialogService {
  private logoutSub!: Subscription;
  constructor(
    private dialog: MatDialog,
    private readonly _httpService: HttpService,
    private readonly _authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.logoutSub = this._authService.logoutEnable$.subscribe((enabled) => {
      if (enabled) {
        this.dialog.closeAll(); // or set popupVisible = false if using custom UI
      }
    });
  }

  public showDialog<T>(
    dynamicComponent: any,
    data: T,
    header: string,
    icon: string,
    className: string,
    callback: Function
  ): any {
    return this.dialog.open(ModalDialogComponent, {
      data: {
        component: dynamicComponent,
        data,
        style: {
          header,
          icon:icon,
        },
        callback,
      },
      panelClass: className 
    });
  }

  public showConfirmationBox(data: IModalConfirmation): any {
    return this.dialog.open(ModalConfirmationComponent, {
      data,
    });
  }

  // message: string,
  // apiURL: string,
  // row: any,
  // callbackFn: Function,
  // icon: string = "fa-solid fa-circle-exclamation",
  // header: string = "Confirmation"
  confirmationDialogBox(data: IModalConfirmationForDeleteAndRestore) {
    const rightButtons: IModalButton[] = [
      {
        text: 'Cancel',
        buttonType: IModalButtonType.OUTLINE_DEFAULT,
        callback: () => {},
      },
      {
        text: 'Yes',
        buttonType: IModalButtonType.PRIMARY,
        callback: () => {
          const request$ =
            data.method === 'delete'
              ? this._httpService.delete(data.apiURL)
              : this._httpService.get(data.apiURL);

          request$.subscribe((updatedRow) => {
            data.callbackFn(updatedRow);
          });
        },
      },
    ];

    this.showConfirmationBox({
      icon: data.icon,
      message: data.message,
      header: data.header,
      rightButtons,
    });
  }

  reloadDataConfirmationBox(
    message: string,
    icon: string,
    header: string,
    callbackFn: Function
  ) {
    const rightButtons: IModalButton[] = [
      {
        text: 'Cancel',
        buttonType: IModalButtonType.OUTLINE_DEFAULT,
        callback: () => {},
      },
      {
        text: 'Yes',
        buttonType: IModalButtonType.PRIMARY,
        callback: () => {
          callbackFn(callbackFn);
        },
      },
    ];

    this.showConfirmationBox({
      icon: icon,
      message: message,
      header: header,
      rightButtons,
    });
  }
}
